export class Point {
	lat: number;
	lon: number;

	constructor(lat: number, lon: number) {
		this.lat = lat;
		this.lon = lon;
	}
}
